import { Link } from "react-router-dom";

// import { useNavigate } from 'react-router-dom';
export const ReusableCarasole = ({ task, IMAGE_PATH }) => {


    return (
        <>
            <div className="card reusable-card" style={{padding:'15px'}} >
                <div style={{ minHeight: '180px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

                    <div className="reusable-card-title">
                        {
                            (task.hasOwnProperty('title') && (task.title.value) && (task.title.value.length > 0)) ? task.title.value.slice(0, 1).map((title, idx) => (
                                <span key={`title-${idx}`}>{title}</span>
                            )) : ''
                        }
                    </div>
                    <div className="reusable-card-description">
                        {
                            (task.hasOwnProperty('short_description') && (task.short_description.value) && (task.short_description.value.length > 0)) ? task.short_description.value.slice(0, 1).map((short_description, idx) => (
                                <span key={`short_description-${idx}`}>{short_description}</span>
                            )) : ''
                        }
                    </div>
                    <div className="tags mt-2 mb-2">
                        {
                            (task.hasOwnProperty('technology_used') && (task.technology_used.value) && (task.technology_used.value.length > 0)) ? task.technology_used.value.slice(0, 1).map((skill, idx) => (
                                <>
                                    <div className="tag  align-items-center" key={`skill-${idx}`}   style={{ display: 'inline-block', maxWidth: '120px',whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis',cursor: 'pointer', }}>
                                        <img src={`${IMAGE_PATH}/skill_icon.svg`} alt="Skill Icon" width={16} height={16} className="me-1" />
                                        <span   title={skill} >
                                        {skill}
                                        </span>
                                    </div>
                                    {
                                        task.technology_used.value.length > 1 && (
                                            <div className="" style={{ color: "#00675b", fontSize: '12px', paddingTop: '3px' }}>
                                                +{task.technology_used.value.length - 1} more
                                            </div>
                                        )
                                    }
                                </>
                            )) : ''
                        }
                    </div>

                    {/* <div className='d-flex mt-2'>
                        <div className='me-1'>

                            <img src={`${IMAGE_PATH}/account_circle.svg`} alt="Account Icon" width={20} height={20} />
                        </div>
                        <div>
                            {
                                task?.component_added_by?.value?.length > 0 &&
                                task.component_added_by.value.slice(0, 1).map((user, idx) => (
                                    <div key={`user-${idx}`}>{user}</div>
                                ))
                            }
                        </div>
                        <div className='ms-auto'>
                            {
                                task?.status?.value?.length > 0 && (
                                    <span className='badge badge-beginer'>
                                        {task.status.value[0]}
                                    </span>
                                )
                            }
                        </div>
                    </div> */}
                </div>
                <div style={{ borderTop: '1px solid #DDDDDD' }} className="pt-2 mt-2">
                    <div className='d-flex justify-content-between'>
                        <Link to={`/reusablerepo/detail/${task.artifact_id}`}
                            className='btn btn-outline-dark view-all-btn'>
                            View Details
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
